var map = {
	"./bn-logo-dark.svg": "8551",
	"./bulb-outline.svg": "d944",
	"./guides/BRP.svg": "709e",
	"./guides/CoS-disabled.svg": "4877",
	"./guides/CoS.svg": "2c00",
	"./guides/analytics-disabled.svg": "bece",
	"./guides/analytics.svg": "1811",
	"./guides/badge.svg": "3386",
	"./guides/bag-disabled.svg": "76ee",
	"./guides/bag.svg": "cfb5",
	"./guides/bar-chart.svg": "a762",
	"./guides/bookmarks.svg": "b5ce",
	"./guides/brp-disabled.svg": "2846",
	"./guides/calendar-disabled.svg": "764b",
	"./guides/calendar.svg": "eade",
	"./guides/checks-disabled.svg": "13c7",
	"./guides/checks.svg": "dee3",
	"./guides/cup-disabled.svg": "2f7b",
	"./guides/cup.svg": "dcce",
	"./guides/directions.svg": "9d73",
	"./guides/document-disabled.svg": "996c",
	"./guides/document-verified-disabled.svg": "50a3",
	"./guides/document-verified.svg": "acc9",
	"./guides/document.svg": "a8e2",
	"./guides/documents.svg": "c8b1",
	"./guides/edit-disabled.svg": "e834",
	"./guides/edit.svg": "4393",
	"./guides/energy.svg": "44e4",
	"./guides/entrance-disabled.svg": "86e6",
	"./guides/entrance.svg": "b37a",
	"./guides/envelope.svg": "233b",
	"./guides/folder.svg": "477c",
	"./guides/glasses-disabled.svg": "eb4b",
	"./guides/glasses.svg": "73e4",
	"./guides/heart-disabled.svg": "219d",
	"./guides/heart.svg": "38da",
	"./guides/help-circle-disabled.svg": "edb9",
	"./guides/help-circle.svg": "103a",
	"./guides/hourglass.svg": "8aa9",
	"./guides/inbox-disabled.svg": "a581",
	"./guides/inbox.svg": "012e",
	"./guides/laptop.svg": "cf01",
	"./guides/library-disabled.svg": "7ab2",
	"./guides/library.svg": "ed35",
	"./guides/like-disabled.svg": "cc36",
	"./guides/like.svg": "e9a9",
	"./guides/line-chart.svg": "0d98",
	"./guides/medal-disabled.svg": "c895",
	"./guides/medal.svg": "9a47",
	"./guides/megafon-disabled.svg": "4aa8",
	"./guides/megafon.svg": "3935",
	"./guides/person-disabled.svg": "9e8c",
	"./guides/person.svg": "60d8",
	"./guides/pie-chart-disabled.svg": "b96a",
	"./guides/pie-chart.svg": "6f8c",
	"./guides/pin.svg": "cac5",
	"./guides/plane-disabled.svg": "8db2",
	"./guides/plane.svg": "6928",
	"./guides/presentation-disabled.svg": "8941",
	"./guides/presentation.svg": "acc7",
	"./guides/puzzle-disabled.svg": "33b2",
	"./guides/puzzle.svg": "3cec",
	"./guides/repair-disabled.svg": "4a61",
	"./guides/repair.svg": "7ab4",
	"./guides/rocket-disabled.svg": "dfac",
	"./guides/rocket.svg": "cadb",
	"./guides/search-disabled.svg": "a424",
	"./guides/search.svg": "fc4b",
	"./guides/settings-disabled.svg": "6e30",
	"./guides/settings.svg": "9e73",
	"./guides/shield-disabled.svg": "c963",
	"./guides/shield.svg": "23e5",
	"./guides/smile-disabled.svg": "cd64",
	"./guides/smile.svg": "345b",
	"./guides/sparkle-disabled.svg": "3dbd",
	"./guides/sparkle.svg": "561b",
	"./guides/sync-disabled.svg": "28ec",
	"./guides/sync.svg": "b287",
	"./guides/web-disabled.svg": "4f27",
	"./guides/web.svg": "5a45",
	"./icons/alert-circle.svg": "7851",
	"./icons/chat-icon.svg": "932f",
	"./icons/checkmark-circle.svg": "8a7d",
	"./icons/compliance-premium.svg": "78dc",
	"./icons/document-verified-warning.svg": "ec81",
	"./icons/user-terminated.svg": "2e5c",
	"./logo-white-bg.svg": "b8d4",
	"./nb-logo-christmas.svg": "d307",
	"./nb-logo.svg": "e7b8",
	"./nb.svg": "5242",
	"./party-popper_image.svg": "257a",
	"./rocket-outline.svg": "e91f",
	"./step-checked.svg": "f43d",
	"./upload-add.svg": "b7ed",
	"./upload-disabled.svg": "310c",
	"./upload-doc.svg": "6668",
	"./upload-error-alt.svg": "8167",
	"./upload-error.svg": "d6be",
	"./upload-file.svg": "4ccc",
	"./upload-loading.svg": "0a23",
	"./upload-outdated.svg": "2ca6",
	"./uploader.svg": "9da3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f57b";